// extracted by mini-css-extract-plugin
export default {"tableBase":"style_tableBase__0x8er","tableAllowed":"style_tableAllowed__zUFtM","tableApplied":"style_tableApplied__n00Tg","tableActions":"style_tableActions__-p+KS"};